/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePrebidImportExcludedAuctionRequestDto } from '../../models/create-prebid-import-excluded-auction-request-dto';
import { PrebidImportExcludedAuctionDto } from '../../models/prebid-import-excluded-auction-dto';

export interface CreatePrebidImportExcludedAuction$Params {
  'X-API-Version'?: string;
      body: CreatePrebidImportExcludedAuctionRequestDto
}

export function createPrebidImportExcludedAuction(http: HttpClient, rootUrl: string, params: CreatePrebidImportExcludedAuction$Params, context?: HttpContext): Observable<StrictHttpResponse<PrebidImportExcludedAuctionDto>> {
  const rb = new RequestBuilder(rootUrl, createPrebidImportExcludedAuction.PATH, 'post');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrebidImportExcludedAuctionDto>;
    })
  );
}

createPrebidImportExcludedAuction.PATH = '/api/prebid-import/excluded-auctions';
